import { render, staticRenderFns } from "./BirdDogReferralForm.vue?vue&type=template&id=755694dc&scoped=true&"
import script from "./BirdDogReferralForm.vue?vue&type=script&lang=js&"
export * from "./BirdDogReferralForm.vue?vue&type=script&lang=js&"
import style0 from "./BirdDogReferralForm.vue?vue&type=style&index=0&id=755694dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755694dc",
  null
  
)

export default component.exports